module.exports = __webpack_public_path__ + "media/packs/images/details/attentions-6246df22f398e07c1f89065acf4431b4.svg";